<template>
    <NavigationBar/>
<div class="container-account">
      <div class="content m-3" >
         

        <div class="col">
<img class="logo" src="../assets/tangerine-logo.svg" alt="...">

            <div class="form-container row">
            <div class="col-12 my-3 start-col">
             
                <SendFeedbackForm @submit="handleSubmit"/>
            </div>
            
            </div>
            </div>
        
        </div>
    </div>
  
    <FooterView/>
    
</template>

<script>
import SendFeedbackForm from '@/components/SendFeedbackForm.vue';
import NavigationBar from '@/components/NavigationBar.vue';
import FooterView from '@/components/Footer.vue';
import { auth } from '../../src/firebase.js';
import { createUserWithEmailAndPassword } from 'firebase/auth';

export default{
    name: "SendFeedback",
components: {
    SendFeedbackForm,
    FooterView,
    NavigationBar
  },
  methods:{
    handleSubmit(email,password,firstName,lastName){
        console.log(`${email} ${password} ${firstName} ${lastName}`)
        createUserWithEmailAndPassword(auth, email, password)
  .then((userCredential) => {
    console.log('User signed up:', userCredential.user);
  })
  .catch((error) => {
    console.error(error);
  });
    }
  }
}
</script>

<style>
.container-account{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%; /* or 100vh if it's the viewport */
}
.content{
     
  flex: 1; /* takes all available space */
}
.form-container{
    margin-left: auto;
  margin-right: auto;
}
</style>